<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/procurement-management/invoices"></back-button>
          Add Invoice
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`procurement-management/invoices`"
              >Invoice</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="invoice-tab"
                  data-bs-toggle="tab"
                  href="#invoice"
                  role="tab"
                  aria-controls="invoice"
                  aria-selected="true"
                  >Invoice</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="invoiceDetial-tab"
                  data-bs-toggle="tab"
                  href="#invoiceDetial"
                  role="tab"
                  aria-controls="invoiceDetial"
                  aria-selected="false"
                  >Invoice Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Invoice Sectiion -->
              <div
                class="tab-pane fade show active"
                id="invoice"
                role="tabpanel"
                aria-labelledby="invoice-tab"
              >
                <h4>Invoice</h4>
                <hr />
                <invoice-form :form="form"></invoice-form>
              </div>
              <!-- For Invoice Details -->
              <div
                class="tab-pane fade"
                id="invoiceDetial"
                role="tabpanel"
                aria-labelledby="invoiceDetial-tab"
              >
                <h4>Invoice Details</h4>
                <hr />
                <invoice-detail-form :form="form"></invoice-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import InvoiceForm from "../invoices/invoice-form.vue";
import InvoiceDetailForm from "../invoices/invoice-detail-form.vue";
export default {
  components: { InvoiceForm, InvoiceDetailForm },
  name: "InvoiceCreate",
  data() {
    return {
      form: {
        purchase_order_id: "",

        invoice_details: [
          {
            category_id: "",
          },
        ],
      },

      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.crew = await axios.post("/invoices", this.form);
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/procurement-management/invoices");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
